<template>
  <div class="animated fadeIn">
    <div v-if="!assessment._id">
      <p>Lighthouse Indicator not found, or you do not have access to this screening in the given Org/Group context.</p>
    </div>
    <div v-if="assessment._id">
      <b-row class="mb-3" align-h="between">
          <b-col cols="auto">
              <h4 class="card-title mb-0">{{ assessment.id  }}</h4>
              <div class="small text-muted">Added {{ $utils.formatDate(assessment.timestamp) }}</div>
          </b-col>
          <b-col cols="auto">
              <router-link v-if="isAllowedToCreateOrEditPerson" :to="'/screening/' + assessment.id + '/edit'">
                  <b-button class="mx-0">Edit</b-button>
              </router-link>
              <b-button v-else disabled class="mx-0">Edit</b-button>
          </b-col>
      </b-row>
      <b-row>
          <b-col sm="9">
              <b-card>
                  <div slot="header">
                      <strong>Physical Indicators</strong>
                      <label class="switch switch-sm switch-text switch-danger mb-0 pull-right">
                          <input id="positive_switch" type="checkbox" class="switch-input" v-model="physicalFilter">
                          <span class="switch-label" data-on="Yes" data-off="All"></span>
                          <span class="switch-handle"></span>
                      </label>
                  </div>
                  <b-row>
                      <b-col sm='6' lg='6' v-for="(field, key) in getFields('physical')" :key="key">
                      <b-card :bg-variant='assessment[field.name] === "Yes" ? "danger" : "default"'>
                          <div v-b-tooltip.hover>{{ field.label }}</div>
                          <div class='h4 m-0' v-if="assessment[field.name]"> {{ assessment[field.name] }} </div>
                          <div class='h4 m-0' v-if="!assessment[field.name]"> No Answer </div>
                      </b-card>
                      </b-col>
                  </b-row>
              </b-card>
              <b-card v-if="false" :no-body="true">
                  <div slot="header">
                      <strong>Physical Indicators</strong>
                  </div>
                  <b-row>
                      <b-col>
                          <b-list-group v-for="(field, key) in getFields('physical')" :key="key">
                              <b-list-group-item :variant='assessment[field.name] === "Yes" ? "danger" : "light"'>{{ field.label }}</b-list-group-item>
                          </b-list-group>
                      </b-col>
                  </b-row>
              </b-card>
              <b-card>
                  <div slot="header">
                      <strong>Behavioral Indicators</strong>
                      <label class="switch switch-sm switch-text switch-danger mb-0 pull-right">
                          <input id="positive_switch_2" type="checkbox" class="switch-input" v-model="behavioralFilter">
                          <span class="switch-label" data-on="Yes" data-off="All"></span>
                          <span class="switch-handle"></span>
                      </label>
                  </div>
                  <b-row>
                      <b-col sm='6' lg='6' v-for="field in getFields('behavioral')" v-bind:key="field.name">
                          <b-card :bg-variant='assessment[field.name] === "Yes" ? "danger" : "default"'>
                              <div v-b-tooltip.hover>{{ field.label }}</div>
                              <div class='h4 m-0' v-if="assessment[field.name]"> {{ assessment[field.name] }} </div>
                              <div class='h4 m-0' v-if="!assessment[field.name]"> No Answer </div>
                          </b-card>
                      </b-col>
                  </b-row>
              </b-card>
              <b-card>
                  <div slot="header">
                      <strong>Psychological Indicators</strong>
                      <label class="switch switch-sm switch-text switch-danger mb-0 pull-right">
                          <input id="positive_switch_2" type="checkbox" class="switch-input" v-model="psychologicalFilter">
                          <span class="switch-label" data-on="Yes" data-off="All"></span>
                          <span class="switch-handle"></span>
                      </label>
                  </div>
                  <b-row>
                      <b-col sm='6' lg='6' v-for="field in getFields('psychological')" v-bind:key="field.name">
                          <b-card :bg-variant='assessment[field.name] === "Yes" ? "danger" : "default"'>
                              <div v-b-tooltip.hover>{{ field.label }}</div>
                              <div class='h4 m-0' v-if="assessment[field.name]"> {{ assessment[field.name] }} </div>
                              <div class='h4 m-0' v-if="!assessment[field.name]"> No Answer </div>
                          </b-card>
                      </b-col>
                  </b-row>
              </b-card>
              <b-card>
                  <div slot="header">
                      <strong>Medical Indicators</strong>
                      <label class="switch switch-sm switch-text switch-danger mb-0 pull-right">
                          <input id="positive_switch_3" type="checkbox" class="switch-input" v-model="medicalFilter">
                          <span class="switch-label" data-on="Yes" data-off="All"></span>
                          <span class="switch-handle"></span>
                      </label>
                  </div>
                  <b-row>
                      <b-col sm='6' lg='6' v-for="field in getFields('medical')" v-bind:key="field.name">
                          <b-card :bg-variant='assessment[field.name] === "Yes" ? "danger" : "default"'>
                              <div v-b-tooltip.hover>{{ field.label }}</div>
                              <div class='h4 m-0' v-if="assessment[field.name]"> {{ assessment[field.name] }} </div>
                              <div class='h4 m-0' v-if="!assessment[field.name]"> No Answer </div>
                          </b-card>
                      </b-col>
                  </b-row>
              </b-card>
              <b-card>
                  <div slot="header">
                      <strong>Follow-up Questions</strong>
                  </div>
                  <b-row v-if="assessment.q_safe">
                      <b-col sm="12">
                          <b-card border-variant='default'>
                              <b-row>
                                  <b-col lg="4">
                                      <div class="questionlabel">Are you safe?</div>
                                      <div class='h4 m-0'> {{ assessment.q_safe }} </div>
                                  </b-col>
                                  <b-col lg="8">
                                      <h6 class="questionlabelsm" v-if="assessment.d_safe">Details</h6>
                                      <div v-if="assessment.d_safe" class='p mt-2 preserve-whitespace'> {{ assessment.d_safe }} </div>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </b-col>
                  </b-row>
                  <b-row v-if="assessment.q_doctor">
                      <b-col sm="12">
                          <b-card border-variant='default'>
                              <b-row>
                                  <b-col lg="4">
                                      <div class="questionlabel">Do you want to see a doctor?</div>
                                      <div class='h4 m-0'> {{ assessment.q_doctor }} </div>
                                  </b-col>
                                  <b-col lg="8">
                                      <h6 class="questionlabelsm" v-if="assessment.d_doctor">Details</h6>
                                      <div v-if="assessment.d_doctor" class='p mt-2 preserve-whitespace'> {{ assessment.d_doctor }} </div>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </b-col>
                  </b-row>
                  <b-row v-if="assessment.q_anybody">
                      <b-col sm="12">
                          <b-card border-variant='default'>
                              <b-row>
                                  <b-col lg="4">
                                      <div class="questionlabel">Are you with anybody?</div>
                                      <div class='h4 m-0'> {{ assessment.q_anybody }} </div>
                                  </b-col>
                                  <b-col lg="8">
                                      <h6 class="questionlabelsm" v-if="assessment.d_anybody">Details</h6>
                                      <div v-if="assessment.d_anybody" class='p mt-2 preserve-whitespace'> {{ assessment.d_anybody }} </div>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </b-col>
                  </b-row>
                  <b-row v-if="assessment.q_finding">
                      <b-col>
                          <b-card border-variant='default'>
                              <b-row>
                                  <b-col lg="4">
                                      <div class="questionlabel">Are you worried about someone finding you?</div>
                                      <div class='h4 m-0'> {{ assessment.q_finding }} </div>
                                  </b-col>
                                  <b-col lg="8">
                                      <h6 class="questionlabelsm" v-if="assessment.d_finding">Details</h6>
                                      <div v-if="assessment.d_finding" class='p mt-2 preserve-whitespace'> {{ assessment.d_finding }} </div>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </b-col>
                  </b-row>
                  <b-row v-if="assessment.q_someone">
                      <b-col>
                          <b-card border-variant='default'>
                              <b-row>
                                  <b-col lg="4">
                                      <div class="questionlabel">Do you wish someone else was taking care of you?</div>
                                      <div class='h4 m-0'> {{ assessment.q_someone }} </div>
                                  </b-col>
                                  <b-col lg="8">
                                      <h6 class="questionlabelsm" v-if="assessment.d_someone">Details</h6>
                                      <div v-if="assessment.d_someone" class='p mt-2 preserve-whitespace'> {{ assessment.d_someone }} </div>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </b-col>
                  </b-row>
                                      <b-row v-if="assessment.q_do_something">
                      <b-col>
                          <b-card border-variant='default'>
                              <b-row>
                                  <b-col lg="4">
                                      <div class="questionlabel">Has anyone made you do something you did not want to do or made you uncomfortable?</div>
                                      <div class='h4 m-0'> {{ assessment.q_do_something }} </div>
                                  </b-col>
                                  <b-col lg="8">
                                      <h6 class="questionlabelsm" v-if="assessment.d_do_something">Details</h6>
                                      <div v-if="assessment.d_do_something" class='p mt-2 preserve-whitespace'> {{ assessment.d_do_something }} </div>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </b-col>
                  </b-row>
                  <b-row v-if="assessment.q_bullied">
                      <b-col>
                          <b-card border-variant='default'>
                              <b-row>
                                  <b-col lg="4">
                                      <div class="questionlabel">Have you been bullied?</div>
                                      <div class='h4 m-0'> {{ assessment.q_bullied }} </div>
                                  </b-col>
                                  <b-col lg="8">
                                      <h6 class="questionlabelsm" v-if="assessment.d_bullied">Details</h6>
                                      <div v-if="assessment.d_bullied" class='p mt-2 preserve-whitespace'> {{ assessment.d_bullied }} </div>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </b-col>
                  </b-row>
                  <b-row v-if="assessment.d_basic_needs">
                      <b-col>
                          <b-card border-variant='default'>
                              <b-row>
                                  <b-col lg="4">
                                      <div class="questionlabel">How do you get your basic needs met?</div>
                                      <div v-if="assessment.d_basic_needs" class='p mt-2'> {{ assessment.d_basic_needs }} </div>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </b-col>
                  </b-row>
                  <b-row v-if="assessment.d_school">
                      <b-col>
                          <b-card border-variant='default'>
                              <b-row>
                                  <b-col lg="4">
                                      <div class="questionlabel">Tell me about school</div>
                                      <div v-if="assessment.d_school" class='p mt-2'> {{ assessment.d_school }} </div>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </b-col>
                  </b-row>
                  <b-row v-if="assessment.d_worst_hurt">
                      <b-col>
                          <b-card border-variant='default'>
                              <b-row>
                                  <b-col lg="4">
                                      <div class="questionlabel">What is the worst you have ever been hurt by someone else?</div>
                                      <div v-if="assessment.d_worst_hurt" class='p mt-2'> {{ assessment.d_worst_hurt }} </div>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </b-col>
                  </b-row>
                  <b-row v-if="assessment.d_hang_out">
                      <b-col>
                          <b-card border-variant='default'>
                              <b-row>
                                  <b-col lg="4">
                                      <div class="questionlabel">Who do you hang out with?</div>
                                      <div v-if="assessment.d_hang_out" class='p mt-2'> {{ assessment.d_hang_out }} </div>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </b-col>
                  </b-row>
              </b-card>
          </b-col>

          <b-col sm="3">
            <!-- Assessment Share Records -->
            <ShareAssessmentList
              :personId="assessment.person._id"
              :assessmentId="assessment._id"
              :assessmentOrganizationOwner="assessment.organizationOwner.id"
            ></ShareAssessmentList>

            <!-- Possible Victim -->
            <b-card :bg-variant='assessment.dmst_conclusion === "Yes" ? "danger" : "default"'>
              <div>Lighthouse Indicators Conclusion</div>
              <div class='h4 m-0'> {{ assessment.dmst_conclusion === "Yes" ? "Possible Trafficking Victim" : "Not Enough Information" }} </div>
            </b-card>

            <!-- Meta -->
            <b-card no-body :title="assessment.id">
              <b-card-body>
                <p class="card-text">
                  <small class="text-muted text-uppercase font-weight-bold">Person ID</small>
                  <br/>
                  <small>
                    <router-link :to="'/person/' + assessment.person_id">
                        {{ assessment.person_id }}
                    </router-link>
                  </small>
                </p>
                <p class="card-text">
                  <small class="text-muted text-uppercase font-weight-bold">First Recorded</small>
                  <br/>
                  <small class="text-muted"><b> on: </b> {{ (assessment.createdAt/1000) | unixToHuman }}
                    <div v-if="_.isObject(assessment.createdBy)">
                        <b> by: </b> {{ _.get(assessment, 'createdBy.emailAddress', '') }}
                    </div>
                  </small>
                </p>
                <p class="card-text">
                  <small class="text-muted text-uppercase font-weight-bold">Last Updated</small>
                  <br/>
                  <small class="text-muted"><b> on: </b> {{ (assessment.updatedAt/1000) | unixToHuman }}
                    <div v-if="_.isObject(assessment.updatedBy)">
                        <b> by: </b> {{ _.get(assessment, 'updatedBy.emailAddress', '') }}
                    </div>
                  </small>
                </p>
                <p class="card-text">
                  <small class="text-muted text-uppercase font-weight-bold">Current Record Owner</small>
                  <br/>
                  <small class="text-muted"><b> by: </b> {{ _.get(assessment, 'organizationOwner.title') }} </small>
                </p>
              </b-card-body>
            </b-card>
            <b-card v-if="_.isObject(assessment.location)">
              <div>Location</div>
              <div class='h4 m-0'>{{ assessment.location.title }}</div>
            </b-card>
            <b-card v-if="_.isObject(assessment.program)">
              <div>Program</div>
              <div class='h4 m-0'>{{ assessment.program.title !== 'Other' ? assessment.program.title : assessment.program.title_otherText }}</div>
            </b-card>
          </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import userPermissionMixin from '@/mixins/userPermission.js'

import ShareAssessmentList from '@/components/Assessment/ShareAssessmentList'

export default {
  name: 'assessment',
  mixins: [userPermissionMixin],
  components: {
    ShareAssessmentList
  },
  computed: {
    ...mapGetters({
      assessmentFields: 'getAssessmentFields',
      assessment: 'getViewAssessment',
      person: 'getAssessmentPerson',
      userCurrentContext: 'userCurrentContext'
    })
  },
  // Wait until we find the assessment, then go get the person information
  watch: {
    assessment: function (newValue, oldValue) {
      if (newValue) {
        console.log(newValue)
        this.populateRelatedRecords()
      }
    },
    userCurrentContext: function (newValue) {
      if (newValue) {
        this.populateAssessment()
        // this.populateRelatedRecords()
      }
    }
  },
  methods: {
    excludes: function () {
      return [
        // 'my_field'
      ]
    },
    getFields: function (categoryName) {
      let isCategoryFilterOn = this[categoryName + 'Filter']

      let fields = this.assessmentFields
      let exclusions = this.excludes()
      let _ = this._
      let assessment = this.assessment

      fields = _.filter(fields, function (field) {
        // Remove falsey values - things like '', null, etc.
        if (!_.identity(assessment[field.name])) {
          return false
        }

        // Remove empty dates
        if (assessment[field.name] === '0000-00-00 00:00:00') {
          return false
        }

        // Check our exclusions list
        if (_.includes(exclusions, field.name)) {
          return false
        }

        // Check our category
        if (field.category !== categoryName) {
          return false
        }

        if (isCategoryFilterOn) {
          if (assessment[field.name] !== 'Yes') {
            return false
          }
        }

        // Anything else is a big thumbs up
        return true
      })

      // console.log('final' + fields)
      return fields
    },
    populateAssessment: function () {
      this.$store.dispatch('getAssessment', {
        id: this.id
      })
    },
    populateRelatedRecords: function () {
      this.$store.dispatch('getAssessmentPerson', {
        id: this.assessment.person_id
      })

      this.$store.dispatch('addViewAssessmentLog', {
        _id: this.assessment._id
      })
    }
  },
  data: function () {
    return {
      physicalFilter: false,
      behavioralFilter: false,
      psychologicalFilter: false,
      medicalFilter: false
    }
  },
  beforeDestroy: function () {
    this.$store.commit('resetAssessment')
  },
  created: function () {
    this.id = this.$route.params.id

    this.populateAssessment()
  }
}
</script>

<style scoped>
    .preserve-whitespace {
        white-space: pre-wrap;
    }
</style>


// WEBPACK FOOTER //
// src/views/t1/Assessment.vue